import { emitFrontendDiagnostic, frontendDiagnosticsEvents } from '@emporion/ui'
import type {
  AdminExtensionDiagnosticEvent,
  AdminExtensionDiagnosticPayload,
} from './admin-extension-contract'

const diagnosticSubscribers = new Set<(payload: AdminExtensionDiagnosticPayload) => void>()

export const logAdminExtensionDiagnostic = (
  event: AdminExtensionDiagnosticEvent,
  message: string,
  context?: Record<string, unknown>,
) => {
  const payload: AdminExtensionDiagnosticPayload = {
    event,
    message,
    context,
  }
  Array.from(diagnosticSubscribers).forEach((listener) => {
    try {
      listener(payload)
    } catch (error) {
      emitFrontendDiagnostic({
        app: 'admin',
        level: 'warn',
        event: frontendDiagnosticsEvents.adminExtension.diagnosticsListenerFailed,
        message: 'Admin extension diagnostics listener failed',
        context: {
          diagnosticEvent: event,
        },
        error,
      })
    }
  })
  emitFrontendDiagnostic({
    app: 'admin',
    level: event === 'extension_registered' || event === 'extension_disposed' ? 'info' : 'warn',
    event,
    message,
    context,
  })
}

export const subscribeAdminExtensionDiagnostics = (
  listener: (payload: AdminExtensionDiagnosticPayload) => void,
) => {
  diagnosticSubscribers.add(listener)
  return () => {
    diagnosticSubscribers.delete(listener)
  }
}
